import { observer } from 'mobx-react';
import { Button, message } from 'antd';
import {
  useSettings,
  usePhonebook,
  useBackground,
  useCallset,
  useScreensaver,
  useLanguage,
  useTaskbar,
  useFitscreen,
  useMenu,
  useLayout,
  useDesktop,
  useLocalImg,
  useCustomInput,
  useCustomLang,
  useBgImg,
  useThirdApp,
  useProduct,
} from '@/store';
import { useScreenLoading } from '@/components/ScreenLoading';
import { $fm, $t } from '@/Intl';
import * as API from '@/api';
import { downloadFile, extend } from '@/utils';
import { CUR_DEFAULTS } from '@/store/store.params';
import { useGdms } from '@/store';
import { exportAdaptor } from '@/utils/adaptor';

const paramsPatch = (params: ConfigParams) => {
  const result = extend({}, CUR_DEFAULTS, params) as ConfigParams;
  return result;
};

export default observer(() => {
  const [settings] = useSettings();
  const [phonebook] = usePhonebook();
  const [background] = useBackground();
  const [callset] = useCallset();
  const [screensaver] = useScreensaver();
  const [language] = useLanguage();
  const [taskbar] = useTaskbar();
  const [fitscreen] = useFitscreen();
  const [menu] = useMenu();
  const [layout] = useLayout();
  const [desktop] = useDesktop();
  const [localImg] = useLocalImg();
  const [customInput] = useCustomInput();
  const [bgImg] = useBgImg();
  const [customLang] = useCustomLang();
  const [thirdApp] = useThirdApp();
  const [product] = useProduct();
  const { setScreenLoading } = useScreenLoading();
  const { isFromGdms, gdmsToken, gdmsCallback } = useGdms();

  const params = paramsPatch({
    settings,
    phonebook,
    background,
    callset,
    screensaver,
    language,
    taskbar,
    fitscreen,
    menu,
    layout,
    desktop,
  });

  // 常规导出
  const handleExport = async () => {
    setScreenLoading(true);
    exportAdaptor(product, params);
    try {
      const blob = await API.exportCust({
        product,
        params: params,
        localImg,
        customInput,
        bgImg,
        customLang,
        thirdApp,
      });
      downloadFile(blob, `${product}cust`);
    } catch (e) {
      message.error($t('EXPORT_FAILED'));
    }
    setScreenLoading(false);
  };

  // gdms导出
  const handleGDMSSave = async () => {
    setScreenLoading(true);
    exportAdaptor(product, params);
    try {
      const blob = await API.exportCust({
        product,
        params: params,
        localImg,
        customInput,
        bgImg,
        customLang,
        thirdApp,
      });
      const res = await API.saveCustToGdms(
        gdmsCallback,
        gdmsToken,
        new File([blob], `${product}cust`, {
          type: 'application/octet-stream',
        }),
      );

      switch (res.retCode) {
        case 0: {
          message.success($t('SAVE_SUCC'));
          break;
        }
        case 33004: {
          message.error($t('SAVE_FAILED_33004'));
          break;
        }
        default: {
          message.error($t('SAVE_FAILED'));
        }
      }
    } catch (e) {
      message.error($t('SAVE_FAILED'));
    }
    setScreenLoading(false);
  };

  return (
    <Button type='primary' onClick={isFromGdms ? handleGDMSSave : handleExport}>
      {$fm(isFromGdms ? 'SAVE_TO_GDMS' : 'EXPORT_CONFIG')}
    </Button>
  );
});
